import React from "react";
import { DatePicker } from "rsuite";

const PurchaseForm = ({ formik, setShowDistributorModal }) => {
  const { values, handleChange, touched, errors } = formik;

  return (
    <>
     <style>{`
        .rs-input-group { border-radius: 6px !important; border: #e5e5ea solid 1px !important; height: 38px; overflow: hidden; background: white; }
        .rs-input-group .rs-input { border-radius: 5px !important; border: none !important; background: none !important; box-shadow: none !important; }
        .rs-input-group .rs-input:focus { outline: none; box-shadow: none; }
        .rs-picker-toggle { border-radius: 8px !important; }
        .rs-input-group-inside .rs-input { border: none !important; font-size: 14px; border-radius: 8px !important; box-shadow: none !important; background: none !important; }
        .radio-label { cursor: pointer; margin-right: 16px; user-select: none; }
        .error-text { color: #dc3545; font-size: 12px; margin-top: 4px; }
      `}</style>
    <div className="form-section">
      <div className="form-row">
        <div className="form-group">
          <label>PURCHASE TYPE*</label>
          <div className="radio-group">
            {["Invoice"].map((type) => (
              <label key={type} className="radio-label">
                <input
                  type="radio"
                  name="purchaseType"
                  value={type}
                  checked={values.purchaseType === type}
                  onChange={handleChange}
                />
                {type}
              </label>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label>BILL HAS GST COLUMN?*</label>
          <div className="radio-group">
            {["Yes", "No"].map((opt) => (
              <label key={opt} className="radio-label">
                <input
                  type="radio"
                  name="billHasGST"
                  value={opt}
                  checked={values.billHasGST === opt}
                  onChange={handleChange}
                />
                {opt}
              </label>
            ))}
          </div>
        </div>

      {/* Distributor */}
      <div className="form-group">
      <label>DISTRIBUTOR <span className="required">*</span></label>
<input
  className="form-input"
  name="distributorName"
  value={values.distributorName}
  readOnly
  onClick={() => setShowDistributorModal(true)}
  placeholder="Select distributor"
  style={{ cursor: "pointer", backgroundColor: "#f9fafb",height:'38px' }}
/>
    </div>
    </div>

      <div className="form-row">
        <div className="form-group">
          <label>INVOICE NO*</label>
          <input
            type="text"
            name="invoiceNo"
            value={values.invoiceNo}
            onChange={handleChange}
            className="form-input"
            style={{height:'38px'}}
          />
          {touched.invoiceNo && errors.invoiceNo && (
            <span className="error-text">{errors.invoiceNo}</span>
          )}
        </div>

        <div className="form-group">
          <label>INVOICE DATE*</label>
          <DatePicker
  name="invoiceDate"
  oneTap
  format="dd-MMM-yyyy"
  placeholder="Select invoice date"
  placement="topStart"
  value={formik.values.invoiceDate ? new Date(formik.values.invoiceDate) : null}
  onChange={(val) =>
    formik.setFieldValue(
      "invoiceDate",
      val ? val.toLocaleDateString("en-CA") : ""
    )
  }
  style={{ width: "100%", height: "40px", borderRadius: "8px" }}
/>

          {touched.invoiceDate && errors.invoiceDate && (
            <span className="error-text">{errors.invoiceDate}</span>
          )}
        </div>

        {values.purchaseType === "Invoice" && (
          <div className="form-group">
            <label>PAYMENT DUE DATE*</label>
            <DatePicker
  name="paymentDueDate"
  oneTap
  format="dd-MMM-yyyy"
  placeholder="Select due date"
  placement="topStart"
  value={formik.values.paymentDueDate ? new Date(formik.values.paymentDueDate) : null}
  onChange={(val) =>
    formik.setFieldValue(
      "paymentDueDate",
      val ? val.toLocaleDateString("en-CA") : ""
    )
  }
  style={{
    width: "100%",
    height: "40px",
    borderRadius: "8px",
  }}
/>

            {touched.paymentDueDate && errors.paymentDueDate && (
              <span className="error-text">{errors.paymentDueDate}</span>
            )}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default PurchaseForm;
